<app-step-header [title]="title()"
  [description]="description()"
  [state]="state()"
></app-step-header>

<div class="file-step">
  @for (existingFile of existingFiles(); track existingFile) {
    <div class="file existing" [class.removed]="existingFile.removed">
      <button (click)="onDownloadFile(existingFile)" class="name file-download-button" [attr.aria-label]="'Download ' + existingFile.title">{{existingFile.title}}</button>
      @if (editable()) {
        <button (click)="onToggleRemoveExistingFile(existingFile)" class="modifier-button">
          <img src="assets/icons/common/remove.svg" class="icon-remove" alt="Remove existing file {{existingFile.filename}}">
          <img src="assets/icons/common/add.svg" class="icon-keep" alt="Keep existing file {{existingFile.filename}}">
        </button>
      }
    </div>
  }

  @if (editable()) {
    @for (newFile of newFiles(); track newFile) {
      <div class="file new">
        <span class="name">{{newFile.filename}}</span>
        <button (click)="onRemoveNewFile(newFile)" class="modifier-button">
          <img src="assets/icons/common/remove.svg" alt="Remove new file {{newFile.filename}}">
        </button>
      </div>
    }
    <button class="add-file-button" (click)="triggerFileInput()">
      <input #fileInput
        type="file"
        [accept]="fileTypeWhiteList()"
        multiple
        (change)="onAddNewFiles($event)">
        <span>Choose a file</span>
      </button>
    }
  </div>

  <app-step-footer [state]="state()"
    [nextEnabled]="nextEnabled()"
    (previousClicked)="previous()"
    (nextClicked)="save()"
  ></app-step-footer>
